export interface BackgroundItem {
  id: number;
  name?: string | null;
  image_url?: string;
  is_default?: boolean;
  manager_id?: number | null;
}

/**
 * Whether the delete control should be offered for a background.
 *
 * Mirrors what the API enforces, so the UI never offers an action the server
 * will refuse: default backgrounds belong to every doctor and cannot be
 * removed, and a background that is currently selected counts as in use. The
 * doctor switches to another background first, then deletes this one.
 */
export function isBackgroundDeletable(
  background: BackgroundItem | null | undefined,
  currentId: number | null,
  allowDelete: boolean = true,
): boolean {
  if (!allowDelete || !background) {
    return false;
  }
  if (background.is_default) {
    return false;
  }

  return background.id !== currentId;
}

/** Resolves the selected background, or null when it is no longer in the list. */
export function findBackgroundById(
  backgrounds: BackgroundItem[] | null | undefined,
  id: number | null,
): BackgroundItem | null {
  if (!backgrounds || !backgrounds.length || id === null || id === undefined) {
    return null;
  }

  return backgrounds.find((item) => item && item.id === id) || null;
}
